
import {Component} from '@angular/core'

@Component({
    templateUrl:'../view/faq.html'
})

export class FAQComponent {

}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/Home/component/faq.ts